import * as FingerprintJSPro from '@fingerprintjs/fingerprintjs-pro';
import * as  FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DeviceFingerprintService {

  public id$(): Observable<string> {
    let fpPromise;
    if (environment.fingerprintjs.apiKey) {
      fpPromise = FingerprintJSPro.load({
        apiKey: environment.fingerprintjs.apiKey
      });
    } else {
      fpPromise = FingerprintJS.load();
    }
    return new Observable(subscriber => {
      fpPromise
        .then(fp => fp.get())
        .then(result => {
          subscriber.next(result.visitorId);
          subscriber.complete();
        })
        .catch(() => subscriber.complete());
    });
  }
}
